import React from "react";
import NomenclatureSpecificationsPage from "./NomenclatureSpecificationsPage";
import useNomenclatureSpecifications from "./useNomenclatureSpecifications";

function NomenclatureSpecifications(props) {
  return <NomenclatureSpecificationsPage {...useNomenclatureSpecifications(props)} />;
}

export default NomenclatureSpecifications;
